"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("@doshexchnage/utils");
var react_1 = require("react");
var constants_1 = require("../../../constants");
var useClient_1 = require("../../../../../hooks/useClient");
// function EmailCellView({ cellValue }: IProps) {
//   if (!cellValue) {
//     return <div>-</div>;
//   }
//   return <div className="text-nowrap text-sm text-default-foreground">{cellValue.toLowerCase()}</div>;
// }
// export function PriceCellView({ cellValue, client }: IProps) {
//   return (
//     <div className="text-nowrap text-sm capitalize text-default-foreground">
//       {!!cellValue
//         ? formatMoney({
//             symbol: client?.currency_symbol,
//             value: cellValue?.toString() ?? "0",
//             symbolSeparation: true,
//           })
//         : "R 0.00"}
//     </div>
//   );
// }
// function StatusCellView({ cellValue }: IProps) {
//   const color: "warning" | "default" | "primary" | "secondary" | "success" | "danger" = useMemo(() => {
//     if (
//       [
//         "ACTIVE",
//         "COMPLETED",
//         "FUlFILLED",
//         "PROCESSED",
//         "ORDERED",
//         "READY",
//         "ARRIVED",
//         "DELIVERED",
//         "ONLINE",
//         "AVAILABLE",
//         "COMPLETE",
//         "SUCCESS",
//         "ACCEPTED",
//       ].includes(cellValue)
//     ) {
//       return "success";
//     } else if (["INACTIVE", "CANCELLED", "OFFLINE"].includes(cellValue)) {
//       return "default";
//     } else if (["UPDATED", "OPEN", "RETURNED", "PACKED", "VIEWED"].includes(cellValue)) {
//       return "secondary";
//     } else if (["SUSPENDED", "ABANDONED", "RETURNED-BY-CUSTOMER", "DECLINED", "EXPIRED"].includes(cellValue)) {
//       return "danger";
//     } else if (
//       [
//         "AWAITING-SIGNUP",
//         "PROCESSING",
//         "CHECKED-OUT",
//         "POS-ORDERED",
//         "COLLECTED",
//         "DELIVERY-READY",
//         "PARTIALLY-DELIVERED",
//         "AWAITING-EMAIL-CONFIRMATION",
//         "SENT",
//         "PENDING",
//       ].includes(cellValue)
//     ) {
//       return "warning";
//     }
//   }, [cellValue]);
//   return (
//     <Chip className="text-nowrap text-xs capitalize text-default-foreground" color={color} size="md" variant="flat">
//       <div className="p-1">{cellValue}</div>
//     </Chip>
//   );
// }
function useRenderCellViews() {
    var client = (0, useClient_1.useClient)().client;
    var renderCellViews = (0, react_1.useCallback)(function (cellValue) {
        return [
            {
                key: "name",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }),
            },
            {
                key: "surname",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }),
            },
            {
                key: "cell_number",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: cellValue }),
            },
            {
                key: "email",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-default-foreground", children: cellValue }),
            },
            {
                key: "last_order_amount",
                content: ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatMoney)({
                        symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                        value: cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString(),
                        symbolSeparation: true,
                    }) })),
            },
            {
                key: "total_order_value",
                content: ((0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, utils_1.formatMoney)({
                        symbol: client === null || client === void 0 ? void 0 : client.currency_symbol,
                        value: cellValue === null || cellValue === void 0 ? void 0 : cellValue.toString(),
                        symbolSeparation: true,
                    }) })),
            },
            {
                key: "status",
                content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm capitalize text-default-foreground", children: (0, constants_1.TABLE_STATUSES)(cellValue) }),
            },
        ];
    }, [client]);
    return (0, react_1.useMemo)(function () { return ({
        renderCellViews: renderCellViews,
    }); }, [renderCellViews]);
}
